import {
  Stack,
  Card,
  Box,
  FormControl,
  FormLabel,
  TextField,
  FormControlLabel,
  Button,
  Checkbox,
  Divider,
  Typography,
  Link,
  CircularProgress,
  Alert,
  Backdrop,
  Snackbar,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../../axios";
import AppConfig from "../../appConfig";

import ForgotPassword from "./forgot_password";
import Content from "./content";
import AppLogo from "../../app/assets/logo.png";
import { useAuth } from "../../auth_provider";

function LoginPage() {
  const navigate = useNavigate();
  const auth = useAuth();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const [username, setUsername] = useState(null);
  const [password, setPassword] = useState(null);
  const [emailError, setEmailError] = useState(false);
  const [emailErrorMessage, setEmailErrorMessage] = useState("");
  const [passwordError, setPasswordError] = useState(false);
  const [passwordErrorMessage, setPasswordErrorMessage] = useState("");
  const [openForgotPwd, setOpenForgotPwd] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleForgotPwdClose = () => {
    setOpenForgotPwd(false);
  };

  const validateInputs = () => {
    const username = document.getElementById("username");
    const password = document.getElementById("password");

    let isValid = true;

    if (!username.value) {
      setEmailError(true);
      setEmailErrorMessage("Please enter a valid username.");
      isValid = false;
    } else {
      setEmailError(false);
      setEmailErrorMessage("");
    }

    if (!password.value || password.value.length < 6) {
      setPasswordError(true);
      setPasswordErrorMessage("Password must be at least 6 characters long.");
      isValid = false;
    } else {
      setPasswordError(false);
      setPasswordErrorMessage("");
    }

    return isValid;
  };

  const handleSubmit = (event) => {
    if (emailError || passwordError) {
      event.preventDefault();
      return;
    }
    const data = new FormData(event.currentTarget);
    console.log({
      email: data.get("username"),
      password: data.get("password"),
    });

    login(data.get("username"), data.get("password"));
  };

  async function login() {
    const isvalidated = validateInputs();
    if (isvalidated === false) {
      return;
    }

    const u = username;
    const p = password;
    console.log(p);

    setShowLoading(true);
    try {
      const json = { username: u, password: p };
      await axios
        .post("practitioners/authenticate.json", json)
        .then((result) => {
          setShowLoading(false);
          if (result.data.status === "success") {
            // Set token header globally
            axios.defaults.headers.common.token = result.data.data.token.token;
            localStorage.setItem(
              AppConfig.auth_token,
              result.data.data.token.token
            );

            // Set Auth
            auth.setUserObject(result.data.data.user);
            auth.setToken(result.data.data.token.token);
            // response.data.data.token.duration / 60
            // navigate("/dashboard", { replace: true });
            window.location = "/dashboard?nocache=" + (new Date()).getTime();
            return;
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg("An error occurred.");
          setOpen(true);
        });
    } catch (e) {
      setShowLoading(false);
      setErrMsg("An error occurred. Please try again later.");
      setSeverity("error");
      setOpen(true);
    }
  }
  return (
    <>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>

      <Stack
        direction="column"
        component="main"
        sx={[
          {
            justifyContent: "center",
            height: "calc((1 - var(--template-frame-height, 0)) * 100%)",
            marginTop: "max(40px - var(--template-frame-height, 0px), 0px)",
            minHeight: "100%",
          },
        ]}
      >
        <Stack
          direction={{ xs: "column-reverse", md: "row" }}
          sx={{
            justifyContent: "center",
            gap: { xs: 6, sm: 12 },
            p: 2,
            mx: "auto",
          }}
        >
          <Stack
            direction={{ xs: "column-reverse", md: "row" }}
            sx={{
              justifyContent: "center",
              gap: { xs: 6, sm: 12 },
              p: { xs: 2, sm: 4 },
              m: "auto",
            }}
          >
            <Content />
            <Card variant="outlined">
              <Box p={4}>
                <Box
                  align="right"
                  sx={{
                    display: { xs: "flex", md: "none" },
                    mb: 3,
                  }}
                >
                  <img src={AppLogo} alt="" height={"75vh"} />
                </Box>
                <Typography
                  component="h1"
                  variant="h4"
                  sx={{ width: "100%", fontSize: "clamp(2rem, 10vw, 2.15rem)" }}
                >
                  Sign in
                </Typography>
                <Box my={3}>
                  <Divider />
                </Box>
                <Box
                  // component="form"
                  // onSubmit={handleSubmit}
                  noValidate
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                    gap: 2,
                  }}
                >
                  <Box
                    mb={3}
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      width: "100%",
                      gap: 2,
                    }}
                  >
                    <FormControl>
                      <TextField
                        onChange={(e) => {
                          setUsername(e.target.value);
                        }}
                        label="Username"
                        error={emailError}
                        helperText={emailErrorMessage}
                        id="username"
                        type="text"
                        name="username"
                        autoFocus={false}
                        fullWidth
                        variant="outlined"
                        color={emailError ? "error" : "primary"}
                      />
                    </FormControl>
                  </Box>
                  <FormControl>
                    <TextField
                      label="Password"
                      onChange={(e) => {
                        setPassword(e.target.value);
                      }}
                      error={passwordError}
                      helperText={passwordErrorMessage}
                      name="password"
                      placeholder="••••••"
                      type="password"
                      id="password"
                      autoFocus={false}
                      required
                      fullWidth
                      variant="outlined"
                      color={passwordError ? "error" : "primary"}
                    />
                    {/* <Box mt={1} align="right">
                      <Link
                        component="button"
                        type="button"
                        onClick={handleClickOpen}
                        variant="body2"
                        sx={{ alignSelf: "baseline" }}
                      >
                        Forgot password?
                      </Link>
                    </Box> */}
                  </FormControl>
                  {/* <FormControlLabel
                  control={<Checkbox value="remember" color="primary" />}
                  label="Remember me"
                /> */}
                  <ForgotPassword
                    open={openForgotPwd}
                    handleClose={handleForgotPwdClose}
                  />
                  <Box mt={3}>
                    <Button
                      size="large"
                      type="submit"
                      fullWidth
                      variant="contained"
                      onClick={() => {
                        login();
                      }}
                    >
                      Sign in
                    </Button>
                  </Box>
                  {/* <Typography sx={{ textAlign: "center" }}>
                  Don&apos;t have an account?{" "}
                  <span>
                    <Link
                      href="/register"
                      variant="body2"
                      sx={{ alignSelf: "center" }}
                    >
                      Sign up
                    </Link>
                  </span>
                </Typography> */}
                </Box>
              </Box>
            </Card>
          </Stack>
        </Stack>
      </Stack>
    </>
  );
}

export default LoginPage;
